/* unplugin-vue-components disabled */import script from "./dateShose.vue?vue&type=script&setup=true&lang=ts"
export * from "./dateShose.vue?vue&type=script&setup=true&lang=ts"

import "./dateShose.vue?vue&type=style&index=0&id=67b5b76c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b5b76c"]])

export default __exports__